import React, { useEffect } from "react";
import DataTable from "./DataTable";
import moment from "moment";
import { Icons } from "../constants/icon-library";
import { useDispatch, useSelector } from "react-redux";
import { confirmAndDelete } from "./constants";
import { deleteSetting, fetchAllSettingDetails } from "../features/admin/adminSlice";

function Apps() {
  const dispatch = useDispatch();

  const { settings: apps = [] } = useSelector(
    (state) => state.admin
  );

  useEffect(() => {
    dispatch(fetchAllSettingDetails());
  }, [dispatch]);

  const handleRemove = (uuid) => {
    confirmAndDelete({
      uuid,
      dispatch,
      deleteThunk: deleteSetting,
      payloadBuilder: (uuid) => ({ uuid }),
      successMessage: "App removed successfully.",
      errorMessage: "Failed to remove app.",
    });
  };

  const columns = [
    { label: "App", key: "assistantId.name" },
    { label: "Workspace", key: "integrationIds.id1_metadata.name" },
    { label: "Project", key: "integrationIds.id2_metadata.name" },
    { label: "Account Name", key: "userId.name" },
    { label: "Account Email", key: "userId.email" },
    { label: "Created At", key: "createdAt" },
    { label: "Action", key: "action" },
  ];

  const rowRenderer = (a) => (
    <tr key={a.uuid}>
      <td className="align-middle ps-3">
        {a?.assistantId?.name || "-"}
      </td>

      <td className="align-middle ps-3">
        {a?.integrationIds?.id1_metadata?.name ||
          a?.integrationIds?.id1_metadata?.displayName ||
          "-"}
      </td>

      <td className="align-middle ps-3">
        {a?.integrationIds?.id2_metadata?.name ||
          a?.integrationIds?.id2_metadata?.displayName ||
          "-"}
      </td>

      <td className="align-middle ps-3">
        {a?.userId?.name || "-"}
      </td>

      <td className="align-middle ps-3">
        {a?.userId?.email || "-"}
      </td>

      <td className="align-middle ps-3">
        {moment.utc(a?.createdAt).format("MMM D, YYYY • h:mm A")}
      </td>

      <td className="align-middle text-end">
        <button
          className="btn btn-sm text-danger"
          onClick={() => handleRemove(a.uuid)}
        >
          <i className={`wb ${Icons("delete")} fs-8`} />
        </button>
      </td>
    </tr>
  );

  return (
    <div className="content">
      <div className="row">
        <div className="col-12">
          <DataTable
            title="Apps"
            data={apps}
            columns={columns}
            rowRenderer={rowRenderer}
          />
        </div>
      </div>
    </div>
  );
}

export default Apps;